import React, { useEffect, useState } from "react";
import { TextField } from '@mui/material'; // Ensure TextField is imported
import { Dialog } from "@mui/material";
// Custom Cell Renderer for editable inventory

export default function UpdateInventoryCount({ id, value, updateCount }) {
    // const { id, value } = params;

    const [editValue, setEditValue] = useState(value);
    const [confirmInvChange, setConfirmInvChange] = useState(false)

    // Update internal state if the prop value changes (e.g., parent re-renders)
    useEffect(() => {
        setEditValue(value);
    }, [value]);

    const handleChange = (event) => {
        setEditValue(event.target.value);
    };

    const handleBlur = () => {
        if (editValue !== value) {
            setConfirmInvChange(true); // Only show dialog if value has actually changed
        } else {
            setConfirmInvChange(false); // Ensure dialog is closed if no change or reverted
        }
    };

    return (
        <>
            <TextField
                value={editValue}
                onChange={handleChange}
                onKeyDown={(e) => { // Add onKeyDown handler
                    if (e.key === 'Enter') {
                        handleBlur();
                    }
                }}
                onBlur={handleBlur} // Re-enabled onBlur
                type="number" // Set input type to number
                size="small"
                variant="outlined"
                sx={{
                    width: '100%',
                    margin: 0,
                    height: '80%',
                    '& .MuiOutlinedInput-root': {
                        height: '100%',
                        '&:hover fieldset': { borderColor: 'rgba(0, 0, 0, 0.23)' }, // Show subtle border on hover
                        '&.Mui-focused fieldset': { borderColor: 'primary.main' }, // Show primary color border on focus
                    },
                    '.MuiInputBase-input': { padding: '8px', fontSize: '14px' },
                    '.MuiFormControl-root': { margin: 0 }
                }}
                onClick={(e) => e.stopPropagation()} // Prevent row click
                onMouseDown={(e) => e.stopPropagation()} // Prevent row click
            />
            <Dialog open={confirmInvChange} onClose={() => setConfirmInvChange(false)} maxWidth={'sm'}>
                <div style={{ padding: '20px' }}>
                    <div className='row' >
                        <p style={{ display: 'flex', justifyContent: 'center' }}>Confirm Inventory Change</p>
                    </div>
                    <div className='row' style={{ marginTop: '20px' }}>
                        <div className='col-6 text-start'>
                            <button className='submit'
                                onClick={() => {
                                    setConfirmInvChange(false)
                                    setEditValue(value) // Revert to original value on cancel
                                    updateCount(null, null, false) // Notify parent of cancellation
                                }}
                                style={{ width: "100px", height: "30px", backgroundColor: "#e0e0e0", color: 'black' }}>Cancel</button>
                        </div>

                        <div className='col-6 text-end'>
                            <button className='submit'
                                onClick={() => {
                                    setConfirmInvChange(false) // Close dialog
                                    updateCount(id, parseFloat(editValue), true); // Perform save
                                }}
                                style={{ width: "100px", height: "30px", margin: "0 10px 0 0" }}>Save</button>
                        </div>
                    </div>
                </div>
            </Dialog >
        </>
    );
};